/**
 * Canonical supported languages for call-flow IVR spoken prompts.
 * This is deliberately separate from src/i18n/index.js (UI language).
 * A tenant may run the dashboard in French while a call flow speaks English + Arabic.
 *
 * To add a 7th call-flow language:
 *   1. Add its entry here.
 *   2. Add voice text defaults in src/utils/<code>VoiceText.js.
 *   3. Add its voice config to gtts-server/app.py VOICE_BY_LANG.
 *   4. That's it — UtilsThunk, prepareUtilsWithFiles, and the Upload router
 *      all read from SUPPORTED_CALL_LANGS dynamically.
 */

export const SUPPORTED_CALL_LANGS = [
  { code: "en", label: "English",   nativeName: "English",   dir: "ltr" },
  { code: "ar", label: "Arabic",    nativeName: "العربية",   dir: "rtl" },
  { code: "fr", label: "French",    nativeName: "Français",  dir: "ltr" },
  { code: "es", label: "Spanish",   nativeName: "Español",   dir: "ltr" },
  { code: "pt", label: "Portuguese",nativeName: "Português", dir: "ltr" },
];

/** Set of valid call-flow language codes */
export const CALL_LANG_CODES = new Set(SUPPORTED_CALL_LANGS.map((l) => l.code));

/** Quick lookup: code → entry */
export const CALL_LANG_BY_CODE = Object.fromEntries(
  SUPPORTED_CALL_LANGS.map((l) => [l.code, l])
);

/** Max languages per flow (unchanged business rule) */
export const MAX_FLOW_LANGS = 2;

/**
 * Returns true if the given lang code is valid for call-flow use.
 * Case-insensitive to match existing engine behaviour.
 */
export function isValidCallLang(code) {
  return CALL_LANG_CODES.has((code || "").toLowerCase());
}
